import React from 'react'
import { UserChip } from '../../../generated/api/chat-room'
import { AvatarInner } from '../../common/Avatar'

interface ChipAvatarProps {
  chip?: UserChip
  size?: number
  className?: string
  onClick?: () => void
}

export const chipFullName = (chip?: UserChip): string =>
  chip ? [chip.firstName, chip.lastName].filter(Boolean).join(' ') : ''

export const ChipAvatar = ({
  chip,
  size = 40,
  className,
  onClick,
}: ChipAvatarProps): React.ReactNode => (
  <AvatarInner
    alt={`${chipFullName(chip)} avatar`}
    url={chip?.avatarUrl}
    initials={chip?.initials}
    size={size}
    className={className}
    onClick={onClick}
  />
)
